<template>
  <div class="exportStudent">
    <el-page-header
      @back="goBack"
      content="导入学号"
      style="padding: 10px 10px 20px 10px"
    >
    </el-page-header>
    <div class="exportStudent-line">
      <div style="position: relative; width: 100px">
        <el-button type="primary">上传</el-button>
        <input
          class="hidden-input"
          type="file"
          accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="uploadExcel"
        />
      </div>
      <div class="muban" @click="download">点击下载表格模板</div>
      <div class="tips">
        请下载模板，填写学生姓名和学号后上传，A列放学生姓名，B列放学号。
      </div>
    </div>
    <el-table
      class="data-table"
      :data="studentList"
      v-loading="loading"
      height="calc(100vh - 250px)"
    >
      <el-table-column align="center" label="序号" width="50">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 + (page - 1) * 10 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="姓名"
        prop="nick_name"
      ></el-table-column>
      <el-table-column
        align="center"
        label="学号"
        prop="user_name"
      ></el-table-column>
    </el-table>
    <el-pagination
      @current-change="onPageChange"
      :current-page="page"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { import_student, import_list } from '@/api/api.js'
export default {
  name: 'exportStudent',
  data: () => {
    return {
      studentList: [],
      page: 1,
      total: 0,
      loading: false,
    }
  },
  mounted() {
    this.refresPage()
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    download() {
      window.open(
        // 'https://meiyukc.oss-cn-shenzhen.aliyuncs.com/meiyu/file/muban.xlsx'
        'https://meiyukc.oss-cn-shenzhen.aliyuncs.com/meiyu/file/%E5%AD%A6%E5%8F%B7%E4%B8%8A%E4%BC%A0%E8%A1%A8%E5%8D%95.xlsx'
      )
    },
    refresPage() {
      let params = {
        page: this.page,
      }
      this.loading = true
      import_list(params).then((res) => {
        console.log('import_list', res.data)
        this.loading = false
        this.studentList = res.data.data.list
        this.total = res.data.data.total
      })
    },
    onPageChange(e) {
      this.page = e
      this.refresPage()
    },
    uploadExcel(e) {
      let file = e.target.files[0]
      console.log('file', file)
      import_student(file).then(() => {
        this.refresPage()
      })
    },
  },
}
</script>

<style lang="less">
.exportStudent {
  .exportStudent-line {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0;
    .hidden-input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .muban {
      color: #409eff;
      text-decoration: underline;
      cursor: pointer;
    }
    .tips {
      margin-left: 20px;
    }
  }
}
</style>
